import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="fixed z-50 w-full h-full flex justify-center items-center">
      <div className="loader"></div>
    </div>
  );
};

export default Spinner;
